// extracted by mini-css-extract-plugin
export default {"container":"AdminRoutes_container__W269p","containerBody":"AdminRoutes_containerBody__Wr3m7"};